<template>
  <div class="profile-card">
    <WaveSpinner v-if="!info"/>
    <div v-else-if="!editing" class="view">
      <div class="icons" key="view" @click="editing=true">
        <i class="fas fa-edit"/>
      </div>
      <dl>
        <dt>Name:</dt>
        <dd>{{info.first_name}} {{info.last_name}}</dd>
        <dt>Email:</dt>
        <dd>{{info.email}}</dd>
        <template v-for="{label, value} in personalVars">
          <dt :key="label">{{label}}:</dt>
          <dd :key="'dd-'+label">{{value}}</dd>
        </template>
        <template v-if="personalVars.address">
          <dt>Address:</dt>
          <dd><Address class="d-inline-block" v-if="address" :value="address" /></dd>
        </template>
      </dl>
    </div>
    <div v-else class="edit">
      <div v-if="saving" class="icons" key="save" @click="editing=false">
        <i class="fas fa-spinner fa-spin"/>
      </div>
      <div v-else class="icons" key="edit" @click="editing=false">
        <i class="fas fa-times"/>
      </div>
      <b-form class="form" @submit.prevent="onSubmit" @change.native="save">
        <div class="sbs">
          <b-form-input v-model="info.first_name" class="inp" placeholder="First Name" />
          <b-form-input v-model="info.last_name" class="inp" placeholder="Last Name" />
        </div>
        <b-form-input v-model="info.email" class="inp" placeholder="Email" />
        <b-form-input
          v-for="{key, label} in personalVars" :key="key"
          v-model="info[key]" class="inp" :placeholder="label" />
        <EditMemberAddress v-if="personalVars.address" v-model="address" />
      </b-form>
    </div>

  </div>

</template>

<script>
import debouncePromise from "@/lib/debouncePromise";
import { mapGetters, mapActions } from "vuex";
import EditMemberAddress from "./EditMemberAddress";

export default {
  components: {EditMemberAddress},
  props: ['memberId'],
  data() {
    console.log('data!', this.member)
    return {
      saving: false,
      editing: false,
      info: null,
      optimisticAddress: null
    }
  },
  computed: {
    ...mapGetters(["member", "combinedMemberAddresses", "defaultMemberAddress", "personalVars"]),
    address: {
      get() {
        return this.optimisticAddress || this.defaultMemberAddress;
      },
      async set(address) {
        // Ensure the address is immediately reflected in the getter, even
        // though it takes time for the "set" operation to round trip from server.
        this.optimisticAddress = address;
        await this.setDefaultMemberAddress(address);
        // Avoid possible bugs by clearing this cached value.
        this.optimisticAddress = null;
      }
    }
  },
  mounted() {
    console.log('mount', this.info, this.member);
    this.setOrdereeId(this.memberId);
    this.setInfo();
    this.refreshTeamAddresses();
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    this.info = null;
  },
  watch: {
    member: {
      deep: true,
      handler(val, old) {
        console.log('watch: member', this.info, val);
        if (val) this.setInfo();
      }
    },
    info: {
      deep: true,
      handler(val, old) {
        // Save whenever info changes, except the first time (old is null)
        // or last (val is null).
        if (val && old) this.save();
      }
    }
  },
  methods: {
    ...mapActions(['updateUserProfile', 'refreshTeamAddresses', 'setDefaultMemberAddress', 'setOrdereeId']),
    setInfo() {
      if (!this.member || !this.member.id) return; // Only run if this has been set
      if (this.info && this.info.id == this.member.id) return; // Only run once
      let {personal_info={}, id, email, first_name, last_name} = this.member || {};
      this.info = Object.assign({}, {id, email, first_name, last_name}, personal_info);
      console.log('setInfo', this.info, this.setDefaultMemberAddress);
    },
    save: debouncePromise(async function save() {
      this.saving = true;
      let {id, email, first_name, last_name, ...personal_info} = this.info;
      await this.updateUserProfile({id, email, first_name, last_name, personal_info});
      this.saving = false;
    }, 500)
  }
};
</script>

<style lang="scss" scoped>
.profile-card {
  margin: 1em 0 0 0;
  @media (min-width: 576px) {
    width: 100%;
    max-width: 504px;
  }

  dl { font-size: smaller; line-height: 1.25em; margin-bottom: 0; }

  // Extra small devices get browser treatment of dd
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  padding: 0.5em 0;
  @media (min-width: 576px) {
    border: 1px solid #aaa;
    padding: 0.5em 1em;
    // Wider devices get dt/dd side-by-side
    dl { line-height: 2em; }
    dd { display: inline; }
    dd:after { display: block; content: ''; }
    dt { width: 6em; display: inline-block; vertical-align: top; }
  }

  // Edit button appears on right
  position: relative;
  .icons {
    cursor: pointer;
    position: absolute;
    right: 1em;
    top: 0.8em;
    color: #aaa;
  }

  // Hovering over the view mode shows an activatable
  // border/icon
  .view &:hover {
    border-color: #333;
    background: #f8f8f8;
    .icons {
      color: #333;
    }
  }

  .edit .form {
    // Edit leaves space for the icon on right
    width: calc(100% - 2.5em);

    // Add a little gap between everything
    > * { margin: 0.5em 0; }

    .sbs {
      display: flex;
      flex-flow: row nowrap;
      > *:first-child {
        margin-right: 0.5em;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/team/ProfileRow.vue